/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilityApiModel } from './capabilityApiModel';


export interface OccupationCapabilityApiModel { 
    occupationId: number;
    riskFactors: Array<CapabilityApiModel>;
    workActivities: Array<CapabilityApiModel>;
    courses: Array<CapabilityApiModel>;
}

